/**
 * Boton flotante de WhatsApp, presente en toda la tienda (WSP-01).
 *
 * WhatsApp no se reemplaza con el carro: es el canal que hoy cierra ventas, y
 * para buena parte de los clientes es la forma natural de preguntar.
 */
import { SITIO } from '../../configuracion/sitio';
import { registrarClicWhatsapp } from '../../servicios/metricas.servicio';
import { whatsappGeneral } from '../../utilidades/whatsapp';
import { Icono } from '../comunes/Icono';

export function BotonWhatsappFlotante() {
  return (
    <a
      className="wa-flota"
      href={whatsappGeneral()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Escribir a ${SITIO.nombre} por WhatsApp`}
      onClick={() => registrarClicWhatsapp({ origen: 'flotante' })}
    >
      <Icono nombre="wa" />
      <span>Escríbenos</span>
    </a>
  );
}
